import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * PrimeNG-téma a Szirom B2B design-tokenekkel (docs/design/b2b-prototipus/README-Angular-atadas.md).
 * Elsődleges szín #0B6E6A, mezők 12 px, gombok pill (46 px), a felületek a design zöldes-szürke skálája.
 * A komponensek finomhangolása (magasságok, betűk, tábla-sorok) a styles/theme/_szirom-primeng.scss-ben van.
 */
export const SziromPreset = definePreset(Aura, {
  primitive: {
    borderRadius: {
      none: '0',
      xs: '6px',
      sm: '8px',
      md: '12px',
      lg: '16px',
      xl: '20px',
    },
    teal: {
      50: '#E6F2F1',
      100: '#CDE6E4',
      200: '#B7DBD7',
      300: '#7FBDB8',
      400: '#3F958F',
      500: '#0B6E6A',
      600: '#0F5F5B',
      700: '#0F4A47',
      800: '#0C3B39',
      900: '#092C2A',
      950: '#061F1E',
    },
  },
  semantic: {
    primary: {
      50: '{teal.50}',
      100: '{teal.100}',
      200: '{teal.200}',
      300: '{teal.300}',
      400: '{teal.400}',
      500: '{teal.500}',
      600: '{teal.600}',
      700: '{teal.700}',
      800: '{teal.800}',
      900: '{teal.900}',
      950: '{teal.950}',
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{primary.200}',
      offset: '1px',
    },
    formField: {
      paddingX: '14px',
      paddingY: '9px',
      borderRadius: '12px',
      focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: '0 0 0 3px #B7DBD7',
      },
    },
    colorScheme: {
      light: {
        surface: {
          0: '#FFFFFF',
          50: '#F7F9F8',
          100: '#F3F6F5',
          200: '#E4EAE8',
          300: '#DCE5E3',
          400: '#CFDBD8',
          500: '#9FB6B3',
          600: '#7C8C89',
          700: '#5A6B68',
          800: '#3C514E',
          900: '#16302E',
          950: '#0E1F1E',
        },
        primary: {
          color: '{teal.500}',
          contrastColor: '#FFFFFF',
          hoverColor: '{teal.600}',
          activeColor: '{teal.700}',
        },
        highlight: {
          background: '{teal.50}',
          focusBackground: '{teal.100}',
          color: '{teal.700}',
          focusColor: '{teal.700}',
        },
        text: {
          color: '#16302E',
          hoverColor: '#0E1F1E',
          mutedColor: '#5A6B68',
          hoverMutedColor: '#3C514E',
        },
        content: {
          background: '#FFFFFF',
          hoverBackground: '#F3F6F5',
          borderColor: '#DCE5E3',
          color: '#16302E',
          hoverColor: '#16302E',
        },
        formField: {
          background: '#FFFFFF',
          disabledBackground: '#F3F6F5',
          filledBackground: '#FFFFFF',
          filledHoverBackground: '#FFFFFF',
          filledFocusBackground: '#FFFFFF',
          borderColor: '#CFDBD8',
          hoverBorderColor: '#9FB6B3',
          focusBorderColor: '#0B6E6A',
          invalidBorderColor: '#C0533F',
          color: '#16302E',
          disabledColor: '#7C8C89',
          placeholderColor: '#7C8C89',
          invalidPlaceholderColor: '#C0533F',
          floatLabelColor: '#5A6B68',
          floatLabelFocusColor: '#0B6E6A',
          floatLabelActiveColor: '#5A6B68',
          floatLabelInvalidColor: '#C0533F',
          iconColor: '#5A6B68',
          shadow: 'none',
        },
        navigation: {
          item: {
            focusBackground: '#E6F2F1',
            activeBackground: '#E6F2F1',
            color: '#3C514E',
            focusColor: '#0B6E6A',
            activeColor: '#0B6E6A',
            icon: {
              color: '#5A6B68',
              focusColor: '#0B6E6A',
              activeColor: '#0B6E6A',
            },
          },
          submenuLabel: {
            background: 'transparent',
            color: '#7C8C89',
          },
          submenuIcon: {
            color: '#5A6B68',
            focusColor: '#0B6E6A',
            activeColor: '#0B6E6A',
          },
        },
      },
    },
  },
});
